import React, { useState } from 'react';
import { LinkContainer } from 'react-router-bootstrap';

import PolicyModal from './PolicyModal';
import TermsModal from './TermsModal';

import { routes } from '../../constants';

import './app-footer.scss';

const AppFooter = ({ link }) => {
  const [policyIsOpen, setPolicyIsOpen] = useState(false);
  const [termsIsOpen, setTermsIsOpen] = useState(false);

  const year = new Date().getFullYear();

  return (
    <div className="app-footer">
      <div>
        <div className="d-flex">
          <div className="pointer" onClick={() => setPolicyIsOpen(true)}>
            Privacy Policy
          </div>
          <div className="divider" />
          <div className="pointer" onClick={() => setTermsIsOpen(true)}>
            Terms of Service
          </div>
        </div>

        {link === 'sign-up' ? (
          <LinkContainer to={routes.SIGN_UP}>
            <div className="primary pointer">Sign up</div>
          </LinkContainer>
        ) : (
          <LinkContainer to={routes.SIGN_IN}>
            <div className="primary pointer">Have account?</div>
          </LinkContainer>
        )}
      </div>
      <div className="horizontal-divider" />
      <div className="google-captcha-container" style={{ maxWidth: 'fit-content' }}>
        <div>
          This site is protected by reCAPTCHA and the Google{' '}
        </div>
        <div className='d-flex'>
          <a
            href="https://policies.google.com/privacy"
            target="_blank"
            rel="noreferrer"
          >
            Privacy Policy
          </a>{' '}
          and{' '}
          <a
            href="https://policies.google.com/terms"
            target="_blank"
            rel="noreferrer"
          >
            Terms of Service
          </a>{' '}
          apply
        </div>
      </div>
      <PolicyModal open={policyIsOpen} onClose={() => setPolicyIsOpen(false)} year={year} />
      <TermsModal open={termsIsOpen} onClose={() => setTermsIsOpen(false)} year={year} />
    </div>
  );
};

export default AppFooter;
